<div [ngSwitch]="modalType">
  <div *ngSwitchDefault>
    <modal-info
      (events)="onClick($event)"
      [title]="title"
      [message]="message"
      [labelbtnLeft]="textButtonLeft"
      [labelbtnRigth]="textButtonRigth"
      [icon]="icon"
    ></modal-info>
  </div>


  <div *ngSwitchCase="'login'">
    <login-modal
    (events)="onClick($event)"
    [title]="title"
    [message]="message"
    [labelbtnLeft]="textButtonLeft"
    [labelbtnRigth]="textButtonRigth"
    [icon]="icon"
    >
    </login-modal>
  </div>
</div>
